module.exports = __webpack_public_path__ + "media/images/flags/bw-7d478e0b65c14f65ba74cce15d64591c.svg";